import React from 'react'

const InputWithLabel = ({ name,disabled, label, link, handleChange, type = "text" }) => (
  <div className="w-full">
    <label className="block text-[10px] font-black uppercase tracking-widest text-slate-400 mb-1.5 ml-1">
      {label}
    </label>
    <input
      name={name}
      type={type}
      value={link || ""}
      onChange={(e) => handleChange(name, e.target.value)}
      className={disabled 
            ? 'w-full bg-gray-100 text-gray-400 cursor-not-allowed rounded-xl px-4 py-3 text-sm font-medium focus:bg-white focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all':"w-full bg-slate-100/50 border border-slate-200 rounded-xl px-4 py-3 text-slate-700 text-sm font-medium focus:bg-white focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all"}
      placeholder={`Enter your ${label.toLowerCase()}`}
    />
  </div>
);

export default InputWithLabel
